export default __webpack_public_path__ + "static/media/icons8-youtube.f39d9ff4.svg";